














































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import {発注不可型} from '@/type/purchaseorder/item';
import {表示用日付} from '@/type/purchaseorder/order-function';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';

@Component({
  filters: {
    表示用日付を取得(日付: string): string {
      return 表示用日付(日付);
    },
  },
  components: {
    NormalDialog,
  },
})

export default class OrderFailureDialog extends Vue {
  @Prop({default: false})
  private modal!: boolean;

  @Prop({default: []})
  private failureItemList!: 発注不可型[];


  private 戻る() {
    this.$modal.hide('発注エラー表示画面');
    this.$emit('back-failure-order');
  }

  @Watch('modal')
  private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.$modal.show('発注エラー表示画面');
    }
  }

}

